export default {
  name: "ExternEventTableActionMenu",
  props: ["item", "editHelper", "deleteHelper", "applyHelper", "declineHelper"],
  data: () => ({
    hover: false
  })
};
